import script from "./GuardCodeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./GuardCodeEditor.vue?vue&type=script&setup=true&lang=js"

import "./GuardCodeEditor.vue?vue&type=style&index=0&id=08a39cce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a39cce"]])

export default __exports__